import { render, staticRenderFns } from "./client-info-tab.vue?vue&type=template&id=522789c8&scoped=true"
import script from "./client-info-tab.vue?vue&type=script&lang=js"
export * from "./client-info-tab.vue?vue&type=script&lang=js"
import style0 from "./client-info-tab.vue?vue&type=style&index=0&id=522789c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522789c8",
  null
  
)

export default component.exports